import { STATUS } from '@/constants';
import { create } from 'zustand';

const initialState = {
  toasts: [],
};

const useToastStore = create((set) => ({
  ...initialState,

  addToast: (toast) => {
    const exists = useToastStore.getState().toasts.some((t) => t.message === toast.message);
    if (exists) return;

    const toastWithId = {
      ...toast,
      display: 'show',
      id: toast.id || Date.now().toString(),
      state:
        toast.type === STATUS.SUCCESS
          ? 'positive'
          : toast.type === STATUS.FAILURE || toast.type === STATUS.ERROR
          ? 'negative'
          : toast.type === STATUS.WARNING
          ? 'alert'
          : undefined,
    };

    set({ toasts: [toastWithId] });
  },

  removeToast: (toastId) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== toastId),
    }));
  },

  updateToast: (toastId, updatedToast) =>
    set((state) => ({
      toasts: state.toasts.map((t) => (t.id === toastId ? { ...t, ...updatedToast } : t)),
    })),

  reset: () => set({ ...initialState }),
}));

export default useToastStore;
